import NativeSelect from "@material-ui/core/NativeSelect";
import InputLabel from "@material-ui/core/InputLabel";
import styled from "styled-components";

export const StyledSelect = styled(NativeSelect)<{ hasInputLabel?: boolean }>`
  && {
    padding: 0px;
    margin-top: ${props => (props.hasInputLabel ? "0" : "initial")}

    &:before {
      border-bottom-width: 0px !important;
    }
    &:after {
      border-bottom-width: 0px !important;
    }
  }
`;

export const StyledInputLabel = styled(InputLabel)`
  && {
    transform: translate(5px, 20px) scale(1);
    pointer-events: none;
  }

  &&.MuiInputLabel-shrink {
    background: white;
    z-index: 1;
    transform: translate(12px, -5px) scale(0.75);
  }
`;
